import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getInfoIssues, getWarningIssues, getErrorIssues, getIssuesComponent } from '../../../../../../../utils/validationSummary';
import Checkbox from 'components/shared/StandaloneCheckbox';

class PropertyPickerVertical extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.property.value ,
            tempValue:this.props.property.value,
            isChecked: this.isActive()
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);

        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.debounceTimer = null;
    }

    isActive() {
        return this.props.property.value !== 'Off' && this.props.property.value !== this.props.property.valueMeta.off;
    }

    handleChange(e) {
        if(this.state.value==='0' || this.state.value===0){
            this.setState({
                value:null,

            });
        }

        // if (e.target.value === null || e.target.value === undefined || e.target.value.trim() === '') {
        //     return;
        // }

        // const value = this.props.type === null || this.props.type === undefined || this.props.type === 'int'
        //                     ? e.target.value.replace(null)
        //                     : e.target.value;
        this.setState({
            // tempValue: +e.target.value,
            tempValue: e.target.value,
        });
    }

    handleKeyUp_1 (e) {

        if (e.target.value === null || e.target.value === undefined || e.target.value === ''|| ((''+this.state.value) === (''+this.state.tempValue))) {
            return;
        }
        const value = this.state.tempValue;
        this.setState({
            value: ''+value,
        });

        this.props.handleChange(this.props.property.info.name, value);
    }

    handleKeyUp(e) {
        if (
            e.target.value === null ||
            e.target.value === undefined ||
            e.target.value === '' ||
            ('' + this.state.value) === ('' + this.state.tempValue)
        ) {
            return;
        }

        const value = this.state.tempValue;

        // Clear the previous timer
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        // Set a new timer
        this.debounceTimer = setTimeout(() => {
            this.setState({ value: '' + value });
            this.props.handleChange(this.props.property.info.name, value);
        }, 100); // Adjust the delay (in ms) as needed
    }

    componentWillUnmount() {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }

    handleMouseUp(e) {
        if (e.target.value === null || e.target.value === undefined || e.target.value === ''|| ((''+this.state.value) === (''+this.state.tempValue))) {
            return;
        }

        let value = this.state.tempValue;

        //Mirek conversion
        if (this.props.type === "Mirek") {
            value = (+this.state.tempValue) > (+this.state.value)
                ? Math.round(1000000 / (Math.round(1000000 / (+this.state.tempValue)) - 1))
                : Math.round(1000000 / (Math.round(1000000 / (+this.state.tempValue)) + 1));
        }

        this.setState({
            value: ''+value,
            tempValue: ''+value,
        });
        this.props.handleChange(this.props.property.info.name, value);
    }

    handleChangeCheckBox(e) {
        const value = e.target.checked;
        this.setState({ isChecked: value });

        if (value) {
            this.props.handleChange(this.props.property.info.name, this.props.property.valueMeta.initial !== null ? this.props.property.valueMeta.initial : this.props.property.valueMeta.default);
        } else {
            this.props.handleChange(this.props.property.info.name, this.props.property.valueMeta.off);
        }
        if(this.state.value==='Off'){
            this.props.handleChange(this.props.property.info.name, this.props.property.valueMeta.initial !== null ? this.props.property.valueMeta.initial : this.props.property.valueMeta.default);
            this.setState({value:(this.props.property.valueMeta.initial !== null ? this.props.property.valueMeta.initial : this.props.property.valueMeta.default)})
            this.setState({tempValue:(this.props.property.valueMeta.initial !== null ? this.props.property.valueMeta.initial : this.props.property.valueMeta.default)})
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.property.value !== prevProps.property.value) {
            this.setState({
                value: !isNaN(this.props.property.value) ? this.props.property.value : this.props.property.valueMeta.default,
                tempValue: !isNaN(this.props.property.value) ? this.props.property.value : this.props.property.valueMeta.default,
                isChecked: this.isActive(),
            });
        }

        if (this.props.issues !== prevProps.issues) {
            const infos = getInfoIssues(this.props.issues, this.props.property);
            if (infos.length > 0) {
                for (var i=0;i<infos.length;i++) {
                    if (infos[i].savedValue != null) {
                        this.setState({
                            value: infos[i].savedValue,
                            tempValue: infos[i].savedValue,
                        });
                    }
                }
            }
        }
    }

    render() {

        const errors = getErrorIssues(this.props.issues, this.props.property);
        const warnings = getWarningIssues(this.props.issues, this.props.property);

        const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

        // Same renderer as every other property picker: one message per line, and
        // nothing at all when there is no issue (this used to emit an empty
        // warning-text div on every render).
        const issuesComponent = getIssuesComponent(errors, warnings);

        const checkBoxElem = this.props.checkbox
            ? (<Checkbox
                disabled={this.props.disabled}
                checked={this.state.isChecked}
                style={{ paddingTop: '0', paddingBottom: '0' }}
                onChange={this.handleChangeCheckBox} />)
            : null;

        if(this.props.property.info.name === 'led.ser'){
            this.state.value = this.props.property.value;
        }

        return (
            <Col className={this.props.border ? this.props.border + " card-body-feature-col" : "card-body-feature-col"} style={{ borderLeft: "1px solid rgba(0,0,0,.125)", borderRight: "1px solid rgba(0,0,0,.125)", width: 'fit-content', float: 'left' }}>
                <Row style={{ fontWeight: "500", flexWrap: "nowrap" }}>
                    {checkBoxElem}
                    {this.props.title}
                </Row>

                <Row style={{ width: "auto", paddingBottom: "0" }}>
                    <input
                        disabled={this.props.disabled || (this.props.checkbox && !this.isActive())}
                        className={className}
                        name={this.props.property.info.name}
                        type="number"
                        min={this.props.min}
                        max={this.props.max}
                        step={this.props.step}
                        // value={this.props.checkbox && !this.isActive() ? '' : this.state.value}
                        value={this.props.checkbox && !this.isActive() ? '' : this.state.tempValue}
                        onChange ={this.handleChange}
                        onKeyUp={this.handleKeyUp}
                        onMouseUp={this.handleMouseUp} />
                </Row>
                <Row className="unit-measure-current-setting">
                    {this.props.measureUnit}
                </Row>
                <Row>
                    {issuesComponent}
                </Row>
            </Col>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyPickerVertical);
